import getClient from "./ApiClient";
import { readRole } from "@directus/sdk";

async function getRole(id: string) {
  const clientInstance = await getClient();
  return clientInstance.request(readRole(id, {
    fields: ["*", "policies.policy.id", "policies.policy.name"] as any
  }));
}

export default getRole;